import React from "react";
import "./Options.scss";
import {ReactComponent as DimensionsIcon} from "./Dimensions.svg";
import {ReactComponent as ColorsIcon} from "./Colors.svg";
import {ReactComponent as OptionsIcon} from "./Options.svg";

const Options = (props) => {

    const {configurableOthers, configurableColor, configurableMeasurements} = props;

    return (
        <div className="search-hit__options">
            {configurableOthers ? (
                <div className="search-hit__options-item">
                    <DimensionsIcon/> <span>Maße anpassbar</span>
                </div>
            ) : null}

            {configurableColor ? (
                <div className="search-hit__options-item">
                    <ColorsIcon/> <span>Farbe anpassbar</span>
                </div>
            ) : null}

            {configurableMeasurements ? (
                <div className="search-hit__options-item">
                    <OptionsIcon/> <span>weitere Optionen</span>
                </div>
            ) : null}
        </div>
    )
};

export default Options;
